export function buildAddressLabel(address) {
    let {
        house_name = '',
        flat_number = '',
        house_number = '',
        street_line_1 = '',
        town = '',
        postcode = ''
    } = address;

    const addressString = `${house_name}, ${
        house_number || flat_number
    } ${street_line_1}, ${town}, ${postcode}`
        .split(',')
        .map((address) => address.trim())
        .filter((address) => address)
        .join(', ');

    return `${addressString}`;
}
